import { render } from "./OtiOperationActions.vue?vue&type=template&id=f50b7f3a&scoped=true"
import script from "./OtiOperationActions.vue?vue&type=script&lang=js"
export * from "./OtiOperationActions.vue?vue&type=script&lang=js"

import "./OtiOperationActions.vue?vue&type=style&index=0&id=f50b7f3a&lang=scss&scoped=true"

import exportComponent from "D:\\fromUbuntu2\\fromUbuntu\\ferraro\\ferraro_frontend\\node_modules\\.pnpm\\vue-loader@16.8.3_webpack@4.46.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f50b7f3a"]])

export default __exports__